import React from 'react';
import styled from 'styled-components';
import { Typography} from 'antd';

const { Text } = Typography;

const TitleDiv = styled.div`
padding-top: 8px
`;


export default (props) => {

    const { 
        title, 
        value,
        ...rest
    } = props

    return (
        <TitleDiv>
            <div>
                <Text type="secondary">{title}</Text>
            </div>
            <Text { ...rest }>{value}</Text>
        </TitleDiv>
    )

}